import { render, staticRenderFns } from "./Alpha.vue?vue&type=template&id=62e4fbf8&scoped=true"
import script from "./Alpha.vue?vue&type=script&lang=js"
export * from "./Alpha.vue?vue&type=script&lang=js"
import style0 from "./Alpha.vue?vue&type=style&index=0&id=62e4fbf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e4fbf8",
  null
  
)

export default component.exports